<template>
	<div class="letter_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{$t('notice.message')}}</div>
		</div>
		<div class="msg_num">
			<!-- <div class="all_msg"><span>{{data.ok_read_num}}</span>{{$t('notice.unRead')}}</div>
			<div class="read">全部标为已读</div> -->
		</div>
		<div  class="con">
			<div class="vip-box" >
				<div class="header2 flex-b-c">
					<div class="label">{{$t('webindex.custserver')}}</div>
				</div>
				<div class="VipLevel flex-b-c" @click="$router.push('/kefu')">
					<div class="left flex-b-c">
						<van-icon :name="require('../images/shop/1724467557952192.png')" size="36" />
						<span class="level">{{$t('webindex.custserver')}}</span>
					</div>
					<div class="right flex-b-c">
						<span class="clickToEnte">Enter</span>
						<van-icon name="arrow" size="14" />
					</div>
				</div>
				<div class="header2 flex-b-c" style="margin-top: 20px;">
					<div class="label">{{$t('e.SystemNotification')}}</div>
				</div>
			</div>
		</div>
		<div class="msg_box">
			<van-empty :description="$t('orders.noOrders')" v-if="empty" />
			<div v-if="!empty" class="item" v-for="item in data.list" @click="$router.push('/notice/'+item.id)">
				<div class="tit">
					<p class="tips van-ellipsis">
						<span v-if="item['status']==0" style="color: red;">
							<van-icon name="warning-o" size="16" color="red"/>
						</span>
						{{item[title]}}
					</p>
					<p class="time">{{item.add_time}}</p>
				</div>
				<div class="content van-multi-ellipsis--l2" v-html="item[content]"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty
	} from "vant";
	
	import Fetch from "../../utils/fetch";
	Vue.use(Empty);
	export default {
		name: "login",
		data() {
			return {
				title:"title",
				content:"content",
				empty:false,
				data: {},
			};
		},
		created() {
			this.$parent.footer('kefu',true);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/user/notice').then((r) => {
					this.data = r.data;
					r.data.list.length == 0 ?
						(this.empty = true) :
						(this.empty = false);
				});
			},
		}
	};
</script>

<style lang="less" scoped>
	
	.msg_num{
		width:100%;
		height:20px;
		display: flex;
		justify-content: space-between;
		padding: 0 11px 0 20px;
		align-items: center;
		overflow: hidden;
		.all_msg{
			font-size: 14px;
			color: rgba(0,0,0,.8);
			font-weight: bold;
			span{
				color: #F03041;
			}
		}
		.read{
			font-size: 12px;
			color: #3D96FF;
		}
	}
	.msg_box{
		width: 96%;
		margin-left: 2%;
		border-radius: 5px;
		background:rgba(255,255,255,1);
		padding: 0 13px 0 20px;
		box-shadow:0px 2px 9px 2px rgba(160,160,160,0.15);
		
		.item{
			padding: 10px 0 5px 0;
			border-bottom: 1px solid #ECECEC;
			&:last-of-type{
				border-bottom: none;
			}
			.tit{
				display: flex;
				justify-content: space-between;
				align-items: center;
				.tips{
					font-size: 14px;
                    flex: 1;
					line-height: 20px;
					color: rgba(0,0,0,.8);
					font-weight: bold;
				}
				.time{
                    flex: 1;
                    text-align: right;
					font-size: 12px;
					color: rgba(0,0,0,.6);
				}
			}
			.content{
				height: 36px;
				margin-top: 2px;
				line-height: 18px;
				font-size: 13px;
				color: rgba(0,0,0,.6);
			}
		}
	}
	.con {
	    width: 100%;
	    background-color: #fff;
	    padding-bottom: 10px;
		.charts {
		    padding: 16px 16px 0;
		    box-sizing: border-box;
		}
		
		.charts .charts-left {
		    min-height: 170px;
		    display: flex;
		    flex-direction: column;
		    align-items: center;
		    justify-content: space-between;
		    box-sizing: border-box
		}
		
		.charts .charts-left .left-top,.charts .charts-left .left-bottom {
		    position: relative;
		    min-width: 135px;
		    max-width: 135px;
		    box-sizing: border-box;
		    border: 1px solid #F1BB0E;
		    border-radius: 12px;
		    padding: 9px 8px
		}
		
		.charts .charts-left .left-top .char1,.charts .charts-left .left-bottom .char1 {
		    position: absolute;
		    right: 3px;
		    bottom: 8px;
		    height: 100%
		}
		
		.charts .charts-left .left-top div:nth-child(1),.charts .charts-left .left-bottom div:nth-child(1) {
		    font-size: 12px;
			line-height: 19px;
		}
		
		.charts .charts-left .left-top div:nth-child(2),.charts .charts-left .left-bottom div:nth-child(2) {
		    margin-top: -4px;
		    font-size: 20px;
		    font-weight: 700;
			line-height: 32px;
		}
		
		.charts .charts-left .left-top div:nth-child(3),.charts .charts-left .left-bottom div:nth-child(3) {
		    margin-top: -4px;
		    font-size: 10px;
			line-height: 19px;
		}
		
		.charts .charts-left .left-bottom img {
		    position: absolute;
		    right: 0;
		    z-index: 99;
		    width: 37px;
		    height: 16px;
		    top: 50px;
		    left: 60px
		}
		
		.charts .charts-left .left-bottom div:nth-child(3) {
		    background-color: #000;
		    color: #fff;
		    padding: 0 3px;
		    width: max-content;
		    text-align: center;
		    border-radius: 4px
		}
		
		.charts .charts-right1 {
		    margin: 0 6px
		}
		
		.charts .charts-right2 div:nth-child(3) {
		    background-color: #000;
		    color: #fff;
		    padding: 0 3px;
		    width: max-content;
		    text-align: center;
		    border-radius: 4px
		}
		
		.charts .charts-right1,.charts .charts-right2 {
		    flex: 1;
		    position: relative;
		    box-sizing: border-box;
		    min-width: 96px;
		    max-width:112px;
		    min-height: 170px;
		    border: 1px solid #F1BB0E;
		    padding: 6px 6px 0;
		    border-radius: 12px;
		    overflow: hidden
		}
		
		.charts .charts-right1 div:nth-child(1),.charts .charts-right2 div:nth-child(1) {
		    font-size: 12px;
			line-height: 19px;
		}
		
		.charts .charts-right1 div:nth-child(2),.charts .charts-right2 div:nth-child(2) {
		    font-size: 20px;
		    font-weight: 700;
			line-height: 32px;
		}
		
		.charts .charts-right1 div:nth-child(3),.charts .charts-right2 div:nth-child(3) {
		    font-size: 10px;
			line-height: 19px;
			word-break: auto-phrase;
		}
		
		.charts .charts-right1 .char,.charts .charts-right2 .char {
		    position: absolute;
		    bottom: -3px;
		    left: -1px;
		    border-radius: 12px;
		    overflow: hidden
		}
		
		.charts .charts-right1 img,.charts .charts-right2 img {
		    width: 100%;
		    position: absolute;
		    left: 0;
		    bottom: 0
		}
		
		.vip-box {
		    width: 100%;
		    padding: 0 16px;
		    box-sizing: border-box
		}
		
		.vip-box .header2 {
		    padding: 12px 0;
		    width: 100%;
		}
		
		.vip-box .header2 .label {
		    font-weight: 700;
			font-size: 15px;
		    color: #000;
		}
		
		.vip-box .header2 .more {
		    width: 65%
		}
		
		.vip-box .header2 .more .text {
		    font-weight: 700
		}
		
		.vip-box .header2 .more .img {
		    width: 14px;
		    height:14px;
		    margin-left: 3px
		}
		
		.vip-box .svip {
		    background: #F1BB0E;
		    border-radius: 4px;
		    padding: 0 8px;
		    height: 65px;
		    color: #000;
		}
		
		.vip-box .svip span,.vip-box .svip i {
		    font-weight: 700;
		    margin-left: 8px
		}
		
		.vip-box .svip img {
		    width: 36px;
		    height: 36px
		}
		
		.notice-swipe {
		    height: 28px
		}
		
		.notice-swipe .notice-swipe-item {
		    height: 28px;
		    line-height: 28px
		}
		.VipLevel {
		    width: 100%;
		    height:65px;
		    background: #F1BB0E;
		    border-radius: 8px;
		    padding: 0 10px;
		    color: #000
		}
		
		.VipLevel .left .level {
		    font-size: 16px;
		    font-weight: 700;
		    margin-left:10px
		}
		
		.VipLevel .right .clickToEnte {
		    font-size: 14px;
		    font-weight: 700
		}
		.flex-b-s {
		    display: flex;
		    justify-content: space-between;
		    align-items: flex-start;
		}
		
		.flex-b-c {
		    display: flex;
		    justify-content: space-between;
		    align-items: center
		}
	}
</style>
